import styled, { css } from 'styled-components'

const hideNativeScrollbar = css`
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const CategoriesShell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  width: 100%;
  min-width: 0;
`

export const CategoriesRow = styled.nav`
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  touch-action: pan-x;
  ${hideNativeScrollbar}
`

export const CategoriesScrollTrack = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
`

export const CategoriesScrollThumb = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  min-width: 32px;
  border-radius: 4px;
  background: rgba(120, 188, 40, ${({ $isDragging }) => ($isDragging ? 0.75 : 0.5)});
  cursor: ${({ $isDragging }) => ($isDragging ? 'grabbing' : 'grab')};
  touch-action: none;
  user-select: none;
  transition: ${({ $isDragging }) =>
    $isDragging ? 'background 0.15s ease' : 'background 0.15s ease, transform 0.05s linear'};

  &::before {
    content: '';
    position: absolute;
    inset: -6px 0;
  }

  ${CategoriesScrollTrack}:hover & {
    background: rgba(120, 188, 40, 0.7);
  }
`

export const CategoriesInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: safe center;
  gap: 0.5rem;
  width: max-content;
  min-width: 100%;
  box-sizing: border-box;
`

export const CategoryPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  flex-shrink: 0;
  margin-block: 1px;
  padding: 0.5rem 1.4rem;
  border: 1px solid ${({ $active }) => ($active ? '#ffffff' : '#2a2a2a')};
  border-radius: 999px;
  background: ${({ $active }) =>
    $active ? 'linear-gradient(358deg, #78b529, #219c26)' : 'transparent'};
  color: ${({ $active }) => ($active ? '#ffffff' : '#9a9a9a')};
  font-family: 'Chivo', sans-serif;
  font-size: .95rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-shadow: ${({ $active }) => ($active ? '1px 1px 1px rgba(0, 0, 0, 0.28)' : 'none')};
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, transform 0.15s ease;

  &:hover {
    border-color: ${({ $active }) => ($active ? '#ffffff' : '#3d3d3d')};
    background: ${({ $active }) =>
      $active
        ? 'linear-gradient(358deg, #8acc2f, #28b02e)'
        : 'transparent'};
    color: ${({ $active }) => ($active ? '#ffffff' : '#d0d0d0')};
  }

  &:active {
    transform: ${({ $active }) => ($active ? 'scale(0.98)' : 'none')};
  }
`

export const CategoryIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  &::before {
    width: 18px !important;
    height: 18px !important;
  }
`
